import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { IAMService } from "../services/services.module";
import { YMRoutingService } from "@yupma/ui-kit";
import { UrlParams, URLParser } from "../utils";
import { RouteLinkGenerator, RouteName } from "../routing-path";

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(
        private iamService: IAMService,
        private routingService: YMRoutingService
    ) { }
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const iamObject = await this.iamService.getIAMObject();
            if (!iamObject) {
                this.routingService.navigate([RouteLinkGenerator.auth()], {
                    redirect: state.url,
                    queryParams: { [UrlParams.REDIRECT_URI]: state.url }
                });
                return false;
            }

            // Enterprise validation
            if (!this.iamService.getOrganisationId()) {
                await this.iamService.getIAMObject();
            }

            if (this.iamService.getOrganisationId()) {
                return this.isLoggedInEnterpriseRoute(state.url);
            }

            return false;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    private isLoggedInEnterpriseRoute(url: string): boolean {
        const urlEid = URLParser.getOrganisationId(url);
        if (urlEid === RouteName.DEFAULT_ORGANISATION_ID) {
            const newUrl = url.replace(urlEid, this.iamService.getOrganisationId());
            this.routingService.navigateByUrl(newUrl);
            return false;
        } else if (urlEid !== this.iamService.getOrganisationId()) {
            this.routingService.navigate(
                [RouteLinkGenerator.switchOrganisation()],
                { queryParams: { [UrlParams.REDIRECT_URI] : url } }
            );
            return false;
        }
        return true;
    }
}